import {
  List,
  Datagrid,
  TextField,
  NumberField,
  EditButton,
  Button,
  useRecordContext,
} from "react-admin";
import DisplayDateField from "@/components/DisplayDateField";
import { navigateToBaseRoute } from "@/utils/route-utility";

const OpenProjectButton = () => {
  const record = useRecordContext<{ id?: string | number }>();
  if (record?.id == null) return null;
  return <Button label="Open" onClick={() => navigateToBaseRoute("projects", String(record.id))} />;
};

export const ProjectList = () => (
  <List perPage={25} sort={{ field: "updatedAt", order: "DESC" }}>
    <Datagrid
      rowClick={(id) => {
        navigateToBaseRoute("projects", String(id));
        return false;
      }}
    >
      <TextField source="name" />
      <TextField source="code" emptyText="—" />
      <TextField source="status" />
      <NumberField source="estimatedBudget" options={{ style: "currency", currency: "INR" }} />
      <NumberField source="unitAmount" options={{ style: "currency", currency: "INR" }} />
      <DisplayDateField source="estimatedCompletionDate" emptyText="—" />
      <DisplayDateField source="updatedAt" showTime />
      <EditButton />
      <OpenProjectButton />
    </Datagrid>
  </List>
);
